import React from 'react';
import { ReactComponent as ErrorIcon } from 'Assets/svg/new_icons/errorTriangle.svg';
import { HocPopupComponent } from './hocPopupComponent';
import Button from './Button';

function CommonErrorPopup(props) {
  const {
    togglePopup = () => {},
    className = '',
    title = 'Aaah! Something went wrong',
    message = '',
    Icon = ErrorIcon,
  } = props;

  return (
    <HocPopupComponent
      showCloseIcon
      customClassName={`common-error-popup ${className}`}
      closeClick={() => togglePopup()}
    >
      <Icon className="error-icon" />
      <div className="error-title">{title}</div>
      {message ? (
        <div className="error-message">{message}</div>
      ) : (
        <>
          <div className="error-message">Please try again after sometime.</div>
          <div className="error-message second">
            Contact{' '}
            <a
              href="mailto:support@adapt.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@adapt.io
            </a>{' '}
            if the problem persists
          </div>
        </>
      )}
      <Button btnText="Ok" click={() => togglePopup('buttonClick')} />
    </HocPopupComponent>
  );
}

export default CommonErrorPopup;
